import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const AlertsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
  gap: 0.625rem;
  width: 100%;
`

export const AlertTile = styled.div<{ $active?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: ${tokens.space.md};
  border-radius: ${tokens.radius.card};
  background: ${(props) => (props.$active ? tokens.status.danger.bg : tokens.surface.inset)};
  border: 1px solid ${(props) => (props.$active ? 'rgba(255, 91, 91, 0.3)' : tokens.border.hairline)};
  cursor: pointer;
  transition: transform 0.15s ease, border-color 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: ${(props) => (props.$active ? 'rgba(255, 91, 91, 0.55)' : tokens.border.strong)};
  }
`

export const AlertTileTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const AlertTileIcon = styled.div<{ $active?: boolean }>`
  width: 1.875rem;
  height: 1.875rem;
  border-radius: ${tokens.radius.chip};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => (props.$active ? 'rgba(255, 91, 91, 0.18)' : tokens.surface.raised)};
  color: ${(props) => (props.$active ? tokens.status.danger.fg : tokens.text.muted)};

  svg {
    width: 1.05rem;
    height: 1.05rem;
    fill: currentColor;
  }
`

export const AlertTileCount = styled.span<{ $active?: boolean }>`
  font-size: ${tokens.font.display};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  color: ${(props) => (props.$active ? tokens.status.danger.fg : tokens.text.secondary)};
`

export const AlertTileName = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
  line-height: 1.3;
`
